/* 
    Allows communication between components without parent-child relationship
    Compatible with Vue 2.7 and Vue 3
    How to use:
        - Import eventBus from 'plugins/eventBus'
        - eventBus.$on to listen
        - eventBus.$emit to trigger
        - eventBus.$off to remove listeners
        - eventBus.$once to listen once
*/

class EventBus {
  constructor () {
    this.events = new Map();
  }

  $on (event, handler,) {
    if (!this.events.has(event,)) {
      this.events.set(event, [],);
    }
    this.events.get(event,).push(handler,);
  }

  $off (event, handler,) {
    if (!this.events.has(event,)) { return; }

    if (!handler) {
      // Remove all listeners of the event
      this.events.delete(event,);
    } else {
      // Remove only the specific handler
      const handlers = this.events.get(event,);
      const index = handlers.indexOf(handler,);
      if (index > -1) {
        handlers.splice(index, 1,);
      }
      if (handlers.length === 0) {
        this.events.delete(event,);
      }
    }
  }

  $emit (event, ...args) {
    if (!this.events.has(event,)) { return; }

    const handlers = this.events.get(event,).slice(); // Copy to avoid problems if handlers are removed during execution
    handlers.forEach((handler,) => {
      try {
        handler(...args,);
      } catch (error) {
        console.error(`Error in event handler for "${event}":`, error,);
      }
    },);
  }

  $once (event, handler,) {
    const wrappedHandler = (...args) => {
      handler(...args,);
      this.$off(event, wrappedHandler,);
    };
    this.$on(event, wrappedHandler,);
  }

  // Clear all events (useful for tests or cleanup)
  $clear () {
    this.events.clear();
  }
}

const eventBus = new EventBus();

export default eventBus;
